import React from 'react';

import { MenuItem, TextField } from '@mui/material';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { get } from 'lodash';
import { enumT, T } from '../../../../../utils/helper';

const MUISelectField: React.FC<MUIFieldProps> = (props) => {
	const { label, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;
	return (
		<TextField
			select
			label={label}
			value={typeof fieldValue === 'object' ? (get(props, 'options', []).length > 0 ? fieldValue.id : '') : fieldValue}
			onChange={updateFieldValue}
			disabled={isDisabled}
			error={error}
			helperText={errorMessage}
			fullWidth
			{...restProps}
		>
			{get(props, 'options')
				? get(props, 'options', []).map((ele: any, i: number) => {
						if (get(ele, 'label')) {
							return (
								<MenuItem key={i} value={get(ele, 'value')}>
									{get(ele, 'label')}
								</MenuItem>
							);
						} else {
							return (
								<MenuItem key={i} value={ele}>
									{enumT(ele)}
								</MenuItem>
							);
						}
					})
				: get(props, 'enum', []).map((ele: string, i: number) => (
						<MenuItem key={i} value={ele}>
							{T(`${'AW_' + ele}`)}
						</MenuItem>
					))}
		</TextField>
	);
};

export default MUISelectField;
